import React, { Component } from 'react';
import { withRouter } from 'react-router';

import Functions from '../utils/functions';
import Parts from '../parts/parts';
import Configuration from '../utils/configuration';

class Pages extends Component {
    componentWillUpdate() {
        document.querySelector(".loadRecursiveScripts").remove();
    }
    componentDidUpdate() {
        this.loadMap();
    }
    componentDidMount() {
        this.loadMap();
    }
    loadMap = () => {
        let loadScript = document.createElement("script");
        loadScript.className = "loadRecursiveScripts";
        loadScript.setAttribute("src", `${Configuration.WEB_PATH}js/loadRecursiveScripts.js`);
        document.body.appendChild(loadScript);
    }
    render() {
        let path = Functions.getActualPath(this.props.location.pathname);
        let element = path ? this.props.data[path] : false;
        let parts = element && element.data.parts;
        return (
            <div className="blocks">
                {
                    parts &&
                        parts.map(part =>
                            <Parts part={part} key={`block-${part.sort}`}/>
                        )
                }
            </div>
        )
    }
}

export default withRouter(Pages);
